import generateForm from 'functions/generate-form'
import store from "../store";

const submitVirtualForm = (target, formData, formAttributes = {}) => {

	const curState = store.getState();

	let defaultFormAttributes = {
		'method': 'POST',
		'accept-charset': 'UTF-8'
	}
	let newAttributes = {...defaultFormAttributes, ...formAttributes};

	let submitForm = generateForm({...formData, 'Access-Token': curState.user.accessToken});
	submitForm.setAttribute('action', target);

	for (let key in newAttributes) {
		submitForm.setAttribute(key, newAttributes[key]);
	}

	document.body.appendChild(submitForm);

	setTimeout(() => {
		submitForm.submit();
	}, 250);
	
}

export default submitVirtualForm